import { appActions } from '@app';
import { useAction } from './useAction';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
export function useLogout() {
    const navigate = useNavigate();
    const hardResetApp = useAction(appActions.hardResetApplication);
    const logout = useCallback(() => {
        hardResetApp();
        navigate('/', { replace: true });
    }, [hardResetApp, navigate]);
    return logout;
}
